export function useColorStyle(theme: string, filter?: boolean) {
  const isDark = theme === "dark";
  const colorStyles = {
    option: (provided, state) => ({
      backgroundColor: state.isSelected
        ? isDark
          ? "#D9D9D9"
          : "#808080"
        : "inherit",
      padding: "8px",
      cursor: "pointer",
      fontFamily: "Switzer",
      fontSize: "12px",
      fontWeight: "400",
      color: state.isSelected
        ? isDark
          ? "#000"
          : "#fff"
        : isDark
        ? "#fff"
        : "#000",
      lineHeight: "15.84px",
      ":hover": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#696969"
          : "#D9D9D9",
      },
      ":focus": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#2A2C30"
          : "#D9D9D9",
      },

      ":active": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#2A2C30"
          : "#D9D9D9",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#2A2C30" : "white",
    }),

    control: () => ({
      width: "100%",
      height: 35,
      border: theme === "dark" ? ".5px solid #4E5966" : ".5px solid #D9D9D9",
      borderRadius: 4,
      fontFamily: "Switzer",
      fontSize: "12px",
      fontWeight: "400",
      color: isDark ? "#fff" : "#000",
      lineHeight: "15.84px",
      display: "flex",
      paddingLeft: "4px",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      const color = theme === "dark" ? "white" : "black";

      return { ...provided, opacity, transition, color };
    },
    input: (provided) => ({
      ...provided,
      color: isDark ? "#D9D9D9" : "#758599",
      "*:focus": {
        "--tw-ring-offset-shadow":
          "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
        "--tw-ring-shadow":
          "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
        " box-shadow":
          "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
      },
    }),
  };

  const campaignColorStyles = {
    placeholder: (provided, state) => ({
      ...provided,
      color: isDark ? "#D9D9D9" : "#758599",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      const color = filter ? "#758599" : isDark ? "white" : "black";

      return { ...provided, opacity, transition, color };
    },
    control: (styles) => ({
      //...styles,
      width: "100%",
      height: filter ? 44 : 35,
      border: theme === "dark" ? ".5px solid #4E5966" : ".5px solid #D9D9D9",
      borderRadius: 4,
      fontFamily: filter ? "Outfit Regular" : "Switzer",
      fontSize: "12px",
      fontWeight: "400",
      color: isDark ? "#fff" : "#000",
      lineHeight: "15.84px",
      display: "flex",
      paddingLeft: "4px",
    }),
    option: (provided, state) => ({
      backgroundColor: state.isSelected
        ? isDark
          ? "#D9D9D9"
          : "#808080"
        : "inherit",
      padding: "8px",
      cursor: "pointer",
      fontFamily: filter ? "Outfit Regular" : "Switzer",
      fontSize: "12px",
      fontWeight: "400",
      color: state.isSelected
        ? isDark
          ? "#000"
          : "#fff"
        : isDark
        ? "#fff"
        : "#000",
      lineHeight: "15.84px",
      ":hover": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#696969"
          : "#D9D9D9",
      },
      ":focus": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#2A2C30"
          : "#D9D9D9",
      },

      ":active": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#2A2C30"
          : "#D9D9D9",
      },
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        height: "20px",
        width: "auto",
        backgroundColor: isDark ? "#333F48" : "#D1D6DD",
        color: isDark ? "#fff" : "#000",
      };
    },
    multiValueLabel: (styles, { data }) => {
      return {
        ...styles,
        fontFamily: "Outfit Regular",
        fontSize: "12px",
        fontWeight: "400",
        color: isDark ? "#fff" : "#000",
      };
    },
    multiValueRemove: (styles, { data }) => {
      return {
        ...styles,
        color: isDark ? "#D9D9D9" : "#758599",
        cursor: "pointer",
        ":hover": {
          color: isDark ? "#fff" : "#000",
        },
      };
    },
    menu: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      backgroundColor: theme === "dark" ? "#2A2C30" : "white",
    }),
    input: (provided) => ({
      ...provided,
      color: isDark ? "#D9D9D9" : "#758599",
      "*:focus": {
        "--tw-ring-offset-shadow":
          "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
        "--tw-ring-shadow":
          "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
        " box-shadow":
          "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
      },
    }),
  };

  const timeColorStyle = {
    container: (styles) => ({
      ...styles,
    }),
    control: (styles) => ({
      backgroundColor: isDark ? "transparent" : "white",
      borderColor: isDark ? "#758599" : "#D9D9D9",
      display: "flex",
      justifyContent: "space-between",
      fontFamily: "switzer",
      height: "32px",
      fontSize: "12px",
      borderWidth: "1px",
      borderRadius: "4px",
      padding: "0px",
      verticalAlign: "center",
      "<div": {
        height: "32px",
      },
      ">div": {
        padding: "2px",
      },
      ">div>div": {
        padding: "2px",
        border: "0px",
      },
      ":hover": {
        borderColor: isDark ? "#758599" : "#D9D9D9",
        outline: "none",
      },
      ":active": {
        borderColor: isDark ? "#758599" : "#D9D9D9",
        outline: "none",
      },
      ":focus": {
        borderColor: isDark ? "#758599" : "#D9D9D9",
        outline: "none",
      },
    }),
    option: (styles, state) => {
      return {
        ...styles,
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : "inherit",
        padding: "8px",
        cursor: "pointer",
        fontFamily: "Switzer",
        fontSize: "12px",
        fontWeight: "400",
        color: state.isSelected
          ? isDark
            ? "#000"
            : "#fff"
          : isDark
          ? "#fff"
          : "#000",
        lineHeight: "15.84px",
        ":hover": {
          backgroundColor: state.isSelected
            ? isDark
              ? "#D9D9D9"
              : "#808080"
            : isDark
            ? "#696969"
            : "#D9D9D9",
        },
        ":focus": {
          backgroundColor: state.isSelected
            ? isDark
              ? "#D9D9D9"
              : "#808080"
            : isDark
            ? "#2A2C30"
            : "#D9D9D9",
        },

        ":active": {
          backgroundColor: state.isSelected
            ? isDark
              ? "#D9D9D9"
              : "#808080"
            : isDark
            ? "#2A2C30"
            : "#D9D9D9",
        },
      };
    },
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#2A2C30" : "white",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      const color = theme === "dark" ? "white" : "black";

      return { ...provided, opacity, transition, color };
    },
  };
  return { colorStyles, campaignColorStyles, timeColorStyle };
}
